export default __webpack_public_path__ + "static/media/creatingForms.30d73bf0.png";